import {
  FrontSide,
  MeshBasicMaterial,
  MeshStandardMaterial,
  MeshStandardMaterialParameters,
  RepeatWrapping,
  Side,
  SRGBColorSpace,
  TextureLoader
} from 'three';
import { defaultPlaneColor } from '@/editor/entities/plane/const';
import { globalStores } from '@/editor/stores';
import { IMaterialInfo } from './material';

export function equalsMaterial(material1: IMaterialInfo, material2: IMaterialInfo) {
  if (material1.id === material2.id) {
    return true;
  }

  return false;
}

export function createColorDefaultParam() {
  return {
    opacity: 1,
    transparent: false,
    roughness: 1,
    metalness: 0,
    envMapIntensity: 1
  };
}

// 添加下共用材质缓存，后面需要使用到单独材质再优化

export const createMaterial = (() => {
  const cache = new Map<string, MeshBasicMaterial | MeshStandardMaterial>();

  return function (materialId: string, is2D: boolean = false, side: Side = FrontSide) {
    const key = `${materialId}-${is2D ? '2d' : '3d'}-${side}`;
    const cachedMaterial = cache.get(key);
    if (cachedMaterial) return cachedMaterial;

    const materialInfo = globalStores.materialStore.getMaterialData(materialId);

    const opacity = materialInfo?.opacity ?? 1;
    const transparent = opacity === 1 ? false : true;
    const params: Partial<MeshStandardMaterialParameters> = {
      color: materialInfo?.color ?? defaultPlaneColor,
      opacity: materialInfo?.opacity ?? 1,
      transparent,
      roughness: materialInfo?.roughness ?? 1,
      metalness: materialInfo?.metalness ?? 0,
      envMapIntensity: materialInfo?.envMapIntensity ?? 1,
      depthTest: true,
      depthWrite: !transparent,
      side,
      userData: {
        shared: true
      }
    };

    if (materialInfo?.texture) {
      const textureLoader = new TextureLoader();
      // 加载贴图
      const texture = textureLoader.load(materialInfo.texture);
      texture.colorSpace = SRGBColorSpace;
      texture.wrapS = RepeatWrapping;
      texture.wrapT = RepeatWrapping;

      params.map = texture;
    }

    if (is2D) {
      Reflect.deleteProperty(params, 'roughness');
      Reflect.deleteProperty(params, 'metalness');
      Reflect.deleteProperty(params, 'envMapIntensity');
    }

    const material = is2D ? new MeshBasicMaterial(params) : new MeshStandardMaterial(params);

    cache.set(key, material);

    return material;
  };
})();
